/**
 * AdminInstallationConnectionRpcClient - AtomRpc integration for the
 * admin installation-connections endpoints
 * (`admin.installation.connections.*`).
 *
 * Drives the Connect & manage panel on the install detail page —
 * provider catalog read + per-installation list/upsert/delete.
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminInstallationConnectionRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminInstallationConnectionRpcClient extends AtomRpc.Tag<AdminInstallationConnectionRpcClient>()(
  "AdminInstallationConnectionRpcClient",
  {
    group: AdminInstallationConnectionRpcs,
    protocol: makeRpcClientLayer(AdminInstallationConnectionRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
